export default __webpack_public_path__ + "static/media/DeleteIcon.b529109f.svg";